module.exports = __webpack_public_path__ + "img/join.55e76421.png";